import React from 'react'
import whychooseimage from "../../../Assests/AboutUs/whychooseimage.png"

function MobileViewWhyChooseVizzhy() {
  return (
    <div className='WhyChooseVizzhy '>

            <div className='row w-100  fw-bold missionandvisiontextcolor mission-vison-main-text' style={{fontSize:"1.4rem"}}>
                <div className='ps-4'>Why Choose Vizzhy? </div>
            </div>

            <div>
            <div className='d-flex justify-content-center align-items-center mt-5'> 
            <img src={whychooseimage} style={{width:"60%"}} alt='whychoosevizzhy'/>
            </div>
            </div>

            <div className='row w-100 p-3'>
                <div className='col-md-6 w-50'>
                    <div className='fw-bold missionandvisiontextcolor fs-6 mt-4 mission-vison-sub-text'>Generative AI for Health</div>
                    <div className=' mt-3 mission-vison-para-text' style={{fontSize:".9rem"}}>Our generative AI model, 
                        built on over 1 billion health data points and capable of analyzing 
                        up to 350 GB of personal health data across 3 billion factors, 
                        delivers personalized insights by assessing genes, metabolism,
                         diet, stress, and sleep for proactive health management.</div>
                </div>
                <div className='col-md-6 w-50'>
                    <div className='fw-bold missionandvisiontextcolor fs-6 mt-4 mission-vison-sub-text'>P5 Medicine</div>
                    <div className=' mt-3 mission-vison-para-text' style={{fontSize:".9rem"}}>Our approach is Predictive, Preventive, Precision, Participatory,
                         and Personalized, delivering care that evolves with you.</div>
                </div>
            </div>


            <div className='row w-100 p-3'>
                <div className='col-md-6 w-50'>
                    <div className='fw-bold missionandvisiontextcolor fs-6 mt-4 mission-vison-sub-text'>Multi-Omics Analysis</div>
                    <div className=' mt-3 mission-vison-para-text' style={{fontSize:".9rem"}}>We leverage the power of genomics (genes), proteomics (proteins), metabolomics (metabolites), 
                        transcriptomics (gene activity), the oral and gut microbiomes (microbial communities), 
                        and lipidomics (fats and lipids) to decode the intricate layers of your biology</div>
                </div>
                <div className='col-md-6 w-50'>
                    <div className='fw-bold missionandvisiontextcolor fs-6 mt-4 mission-vison-sub-text'>IoT-Enabled Health Monitoring</div>
                    <div className=' mt-3 mission-vison-para-text' style={{fontSize:".9rem"}}>Our IoT integration enables continuous real-time tracking of essential health metrics. 
                        Through wearable and connected devices, we monitor your health offering timely, 
                        actionable insights for a proactive, personalized approach to wellness.</div>
                </div>
            </div>        
    </div>
  )
}

export default MobileViewWhyChooseVizzhy